export const programmeContainer =
  'flex flex-auto flex-col justify-center items-center';
export const programmeIcon = 'bg-alertMain text-white mt-12';
